import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class extends PureComponent {
  static propTypes = {
    src: PropTypes.string,
    size: PropTypes.number,
    alt: PropTypes.string,
  };

  static defaultProps = {
    alt: '',
  };

  state = {
    inNotFound: false,
  };

  componentDidMount() {
    const image = new Image();
    image.src = this.src;
    image.onerror = () => this.setState({ isNotFound: true });
  }

  get src() {
    const { src, size } = this.props;

    if (size) return `${src}=s${size}-c`;

    return src;
  }

  render() {
    const { src, size, alt, lead, ...props } = this.props;

    if (this.state.isNotFound) return null;

    return (
      <img src={this.src} width={size} height={size} alt={alt} {...props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Image/Image.js